import { Alert, Snackbar } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useAlertStore } from 'src/stores/AlertStore/AlertStore';

const CustomNotification = observer(() => {
  const {
    showNotification,
    notificationPayload,
    reset,
    callbackOfManualToastClose,
    action,
  } = useAlertStore();

  const handleToastClose = () => {
    if (callbackOfManualToastClose) {
      callbackOfManualToastClose();
    }

    reset();
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={showNotification}
    >
      <Alert
        action={action}
        onClose={handleToastClose}
        severity={notificationPayload?.severity}
        variant="filled"
        sx={{ width: '100%', verticalAlign: 'center' }}
      >
        {notificationPayload?.message}
      </Alert>
    </Snackbar>
  );
});

export default CustomNotification;
